// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root {
  --color-system: #ffffff;
  --color-background: #470060;
  --color-background-center: #691890;
  --color-text: #ffffff;

  --color-primary: #3e005d;
  --color-primary-dark: color-mix(in srgb, var(--color-primary) 80%, black);
  --color-on-primary: #ffffff;
  --color-primary-light: #c289f2;
  --color-primary-container: #feae00;

  --color-secondary: #feae00;
  --color-on-secondary: #3e005d;
  --color-hint: #d1a7f5;
  --color-highlight: #c492ef;
  --color-secondary-container: #c189f1;

  --color-bg: #8c3fcb;
  --color-on-bg: #3e005d;
  --color-card: #8b3fcb;
  --color-canvas: #51167e;
  --color-divider: #6f2aab;

  --color-surface: #5c1e8b;
  --color-on-surface: #ffffff;
  --color-box-shadow: #390056;

  --color-shimmer: #3d005d;
  --color-shimmer-light: rgba(187, 222, 251, 0.27);
  --color-progress: #f80000;
  --color-selection: #6190b5;

  --color-tab: #feae00;
  --color-tab-shadow: #8c4737;
  --color-tab-primary: #3e005d;
  --color-on-tab: #8c4737;
}`, "",{"version":3,"sources":["webpack://./src/themes.css"],"names":[],"mappings":";AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;EAClC,qBAAqB;;EAErB,wBAAwB;EACxB,yEAAyE;EACzE,2BAA2B;EAC3B,8BAA8B;EAC9B,kCAAkC;;EAElC,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,0BAA0B;EAC1B,oCAAoC;;EAEpC,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;;EAExB,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;;EAE3B,wBAAwB;EACxB,gDAAgD;EAChD,yBAAyB;EACzB,0BAA0B;;EAE1B,oBAAoB;EACpB,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;AACzB","sourcesContent":["\n:root {\n  --color-system: #ffffff;\n  --color-background: #470060;\n  --color-background-center: #691890;\n  --color-text: #ffffff;\n\n  --color-primary: #3e005d;\n  --color-primary-dark: color-mix(in srgb, var(--color-primary) 80%, black);\n  --color-on-primary: #ffffff;\n  --color-primary-light: #c289f2;\n  --color-primary-container: #feae00;\n\n  --color-secondary: #feae00;\n  --color-on-secondary: #3e005d;\n  --color-hint: #d1a7f5;\n  --color-highlight: #c492ef;\n  --color-secondary-container: #c189f1;\n\n  --color-bg: #8c3fcb;\n  --color-on-bg: #3e005d;\n  --color-card: #8b3fcb;\n  --color-canvas: #51167e;\n  --color-divider: #6f2aab;\n\n  --color-surface: #5c1e8b;\n  --color-on-surface: #ffffff;\n  --color-box-shadow: #390056;\n\n  --color-shimmer: #3d005d;\n  --color-shimmer-light: rgba(187, 222, 251, 0.27);\n  --color-progress: #f80000;\n  --color-selection: #6190b5;\n\n  --color-tab: #feae00;\n  --color-tab-shadow: #8c4737;\n  --color-tab-primary: #3e005d;\n  --color-on-tab: #8c4737;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
